import { css } from 'lit'

export default css`
  .w3m-modal-content {
    padding: 18px;
    width: 100%;
  }
`
